<template>
  <div 
    class="fill-height mt-2">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-dialog v-model="dialog.confirm"
          @keydown.esc="dialog.confirm = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Konfirmasi Update Status

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.confirm = false; dialog.fullscreen = false; selected.confirm = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin ingin mengubah status menjadi {{ selected.status }}?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="statuses()"
                :loading="process.status"
                :disabled="process.status"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Ubah
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.confirm = false; dialog.fullscreen = false; selected.confirm = [];"
                :disabled="process.status"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card 
          flat
          style="border-radius: 10px;">
          <v-card-text class="pa-5">
            <v-row
              class="pa-0 pb-1">
              <v-col 
                cols="12"
                class="py-0">
                <div v-if="Object.keys(detail_project).length > 0">
                  <div class="mb-2 d-flex align-center">
                    <div class="d-flex align-center">
                      <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 130px; min-width: 130px; max-width: 130px;">
                        Pilih {{ detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu' }}
                      </div>
                      <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                        :
                      </div>
                      <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 2px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;">

                        <ValidationProvider 
                          :name="`Pilih ${detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu'}`" 
                          :rules="`required`" 
                          v-slot="{ errors, valid }">
                          <v-autocomplete
                            
                            filled
                            rounded
                            dense
      
                            :color="set_color"
                            :placeholder="`Pilih ${detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu'}`"
                            :items="count_week_list"
                            item-text="value"
                            item-value="id"
      
                            hide-details
                            v-on:change="fetch()"
      
                            v-model="selected.week"
                            :success="selected.week !== '' && valid"
                            :error-messages="errors"
                            required
                            class="mb-0 fs-12 little-placeholder-autocomplate"
                            style="border-radius: 6px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  {{ errors[0] }}
                                </v-tooltip>
                              </div>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="ml-2 black--text">
                      <div>
                        Total Rencana: <span class="font-weight-bold">{{ total.rencana | price }}</span>
                      </div>
                    </div>
                    <div class="ml-3 black--text">
                      <div>
                        Total Realisasi: <span class="font-weight-bold">{{ total.realisasi | price }}</span>
                      </div>
                    </div>
                  </div>
                  <v-divider class="my-2"></v-divider>
                </div>
                <v-card 
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text class="pa-0">
                    <v-row
                      class="pa-0 mt-0 pb-0">
                      <v-col 
                        cols="12"
                        class="pa-0">
                        <v-card 
                          flat
                          style="border-radius: 10px; border: 1px solid #E7E7E7;">
                          <v-card-text
                            v-if="process.load" 
                            class="pb-0 my-4" 
                            style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
                            <div class="text-center">
                              <div class="mb-4 title">
                                Mohon Tunggu . . .
                              </div>

                              <v-progress-linear
                                :color="set_color"
                                indeterminate
                                rounded
                                height="10">
                              </v-progress-linear>
                            </div>
                          </v-card-text>

                          <div class="view" v-if="!process.load">
                            <div :class="list.length < 1 ? '' : 'wrapper-cco'">
                              <table style="border: 1px solid #ededed; width: 100%;" class="table">
                                <tr>
                                  <th rowspan="2" class="sticky-col one-cco-col" style="font-size: 12px; z-index: 2; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" :style="`background-color: ${set_color};`">No</th>
                                  <th rowspan="2" class="sticky-col second-cco-col" style="font-size: 12px; z-index: 2; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" :style="`background-color: ${set_color};`">Uraian Pekerjaan</th>
                                  <th colspan="6" :style="`background-color: ${set_color};`" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 8px; text-align: center; width: 130px; min-width: 130px; max-width: 130px;">
                                    Realisasi
                                  </th>
                                </tr>
                                <tr>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">Satuan</th>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 100px; min-width: 100px; max-width: 100px;" :style="`background-color: ${set_color};`">Volume</th>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 150px; min-width: 150px; max-width: 150px;" :style="`background-color: ${set_color};`">Total Upah</th>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 150px; min-width: 150px; max-width: 150px;" :style="`background-color: ${set_color};`">Total Material</th>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 160px; min-width: 160px; max-width: 160px;" :style="`background-color: ${set_color};`">Total Alat</th>
                                  <th style="top: 39px !important; font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: right; width: 160px; min-width: 160px; max-width: 160px;" :style="`background-color: ${set_color};`">Jumlah</th>
                                </tr>
                                <tr v-for="(item, index) in list" :key="index" @click="selected.row = (((`100${index}`) + index) * (i+1))" :class="selected.row === (((`100${index}`) + index) * (i+1)) ? 'selected' : ''">
                                  <td class="sticky-col one-cco-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 2px; text-align: center;" :style="item.num_children === 1 ? 'font-weight: 600; background-color: #fff' : item.num_children === 2 ? 'background-color: #fff' : 'background-color: #01bcd512; font-weight: 700;'">
                                    <span v-if="item.code !== undefined">{{ item.code }}</span>
                                  </td>
                                  <td class="sticky-col second-cco-col" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" :style="item.num_children === 1 ? 'font-weight: 600; background-color: #fff' : item.num_children === 2 ? 'background-color: #fff' : 'background-color: #01bcd512; font-weight: 700;'">
                                    <div>
                                      {{ item.name }}
                                    </div>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; text-align: left;" :style="item.num_children === 1 ? 'font-weight: 600; background-color: #fff' : item.num_children === 2 ? 'background-color: #fff' : 'background-color: #01bcd512; font-weight: 700;'">
                                    <span v-if="item.num_children === 2">
                                      {{ item.unit }}
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; text-align: right;" :style="item.num_children === 1 ? 'font-weight: 600; background-color: #fff' : item.num_children === 2 ? 'background-color: #fff' : 'background-color: #01bcd512; font-weight: 700;'">
                                    <span v-if="item.num_children === 2">
                                      {{ item.volume*1 }}
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; text-align: right;" :style="item.num_children === 1 ? 'font-weight: 600; background-color: #fff' : item.num_children === 2 ? 'background-color: #fff' : 'background-color: #01bcd512; font-weight: 700;'">
                                    <span v-if="item.num_children === 2">
                                      {{ item.realisasi_upah*1 | price }}
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; text-align: right;" :style="item.num_children === 1 ? 'font-weight: 600; background-color: #fff' : item.num_children === 2 ? 'background-color: #fff' : 'background-color: #01bcd512; font-weight: 700;'">
                                    <span v-if="item.num_children === 2">
                                      {{ item.realisasi_material*1 | price }}
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; text-align: right;" :style="item.num_children === 1 ? 'font-weight: 600; background-color: #fff' : item.num_children === 2 ? 'background-color: #fff' : 'background-color: #01bcd512; font-weight: 700;'">
                                    <span v-if="item.num_children === 2">
                                      {{ item.realisasi_alat*1 | price }}
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; text-align: right;" :style="item.num_children === 1 ? 'font-weight: 600; background-color: #fff' : item.num_children === 2 ? 'background-color: #fff' : 'background-color: #01bcd512; font-weight: 700;'">
                                    <span v-if="item.num_children === 2">
                                      {{ item.realisasi_total*1 | price }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <v-card-text
                              v-if="list.length === 0"
                              class="pb-0 my-4" style="height: calc( 100vh - 295px ); display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <v-img 
                                  class="mx-auto"
                                  contain
                                  alt="vuetify"
                                  :width="90"
                                  :height="90"
                                  :src="require('@/assets/image/empty.png')">
                                  <!-- <template v-slot:placeholder>
                                    <v-row
                                      class=" "
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template> -->
                                </v-img>
                                <div class="mt-3 fs-16">
                                  Belum ada data
                                </div>
                              </div>
                            </v-card-text>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <div v-if="message.error.length > 0"
                    class="text-left d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

      </section>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        unit: [],
        detail_project: {},
        dialog: {
          snackbar: false,
          confirm: false,
          fullscreen: false
        },
        selected: {
          status: '',
          confirm: [],
          delete: [],
          week: '',
        },
        total: {
          realisasi: 0,
          rencana: 0
        },
        total_duration: 0,
        count_week_list: [],
        count_week: 0,
        form: {
          id: '',
          spk_number: '',
          spk_date: '',
          request_file_object: [],
          request_file: [],
          request_image: [],
          type_file: 'image',
          duration: '',
          rab_value: '',
          contract_value: '',
          pj_implementation: '',
          start_date: '',
          end_date: '',
          holiday: '',
        },
        filename: [],
        upload: {
          image: null,
          document: null,
          image_process: null,
          document_process: null
        },
        all_document: [],
        all_document_process: [],
        client: [],
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,

          image: false,
          document: false,
          image_process: false,
          document_process: false,
          status: false,
          load: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploadfile: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            // this.form.request_file_object.type = 'image'
            this.message.error = ''
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.request_image.push({
                title: '',
                url: this.upload.image.fileuri,
                type: 'image',
                no_surat: '',
                tgl_surat: ''
              })
              this.all_document.push({
                title: '',
                url: this.upload.image.fileuri,
                type: 'image',
                no_surat: '',
                tgl_surat: ''
              })

              this.upload.image = null

              // this.form.request_file_object.url = this.upload.image.fileuri
            }
          }
        },
        deep: true
      },
      'upload.document': {
        handler: function () {
          if (this.upload.document) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.document = this.upload.document.process
            
            if (!this.process.document) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.document.fileuri.match(regexp);
              // CALLBACK FROM UPLOAD IMAGE
              this.filename.push(this.upload.document.filename)
              this.form.request_file.push({
                title: '',
                url: this.upload.document.fileuri,
                type: extension && extension[1],
                no_surat: '',
                tgl_surat: ''
              })
              this.all_document.push({
                title: '',
                url: this.upload.document.fileuri,
                type: extension && extension[1],
                no_surat: '',
                tgl_surat: ''
              })

              this.upload.document = null

              // this.form.request_file_object.url = this.upload.document.fileuri
            }
          }
        },
        deep: true
      },
      'upload.image_process': {
        handler: function () {
          if (this.upload.image_process) {
            // this.form.request_file_object.type = 'image'
            this.message.error = ''
            this.process.image_process = this.upload.image_process.process

            if (!this.process.image_process) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.request_process_image.push({
                title: '',
                url: this.upload.image_process.fileuri,
                type: 'image',
                no_surat: '',
                tgl_surat: ''
              })
              this.all_document_process.push({
                title: '',
                url: this.upload.image_process.fileuri,
                type: 'image',
                no_surat: '',
                tgl_surat: ''
              })
              this.upload.image_process = null

              // this.form.request_file_object.url = this.upload.image.fileuri
            }
          }
        },
        deep: true
      },

      'upload.document_process': {
        handler: function () {
          if (this.upload.document_process) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.document_process = this.upload.document_process.process
            
            if (!this.process.document_process) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.document_process.fileuri.match(regexp);
              // CALLBACK FROM UPLOAD IMAGE
              this.filename.push(this.upload.document_process.filename)
              this.form.request_process_file.push({
                title: '',
                url: this.upload.document_process.fileuri,
                type: extension && extension[1],
                no_surat: '',
                tgl_surat: ''
              })
              this.all_document_process.push({
                title: '',
                url: this.upload.document_process.fileuri,
                type: extension && extension[1],
                no_surat: '',
                tgl_surat: ''
              })
              this.upload.document_process = null

              // this.form.request_file_object.url = this.upload.document.fileuri
            }
          }
        },
        deep: true
      }
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
      this.fetch()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get(`project/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail_project = res.results.data
            this.count_week = res.results.data.rab_duration*1
              for (let i = 1; i <= this.detail_project.rab_duration; i++) {
                this.count_week_list.push(
                  {
                    id: (i*1)-1,
                    value: `${this.detail_project.duration_label === 'hari' ? 'Hari' : 'Minggu'} Ke - ${i}`
                  }
                )
              }
          }
        })
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        
        this.paginationList = pagination
        
        this.process.load = true

        this.limit = pagination.row
        let params = {
          search: this.search,
          pagination_bool: false,
          project_id: this.$route.params.id,
          week: this.selected.week+1
        }
        let url = 'project/coo/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list = []
            this.is_detail = false
            this.total = res.results.total
            res.results.data.map((item, index_par) => {
              this.list.push({
                ...item,
                num_children: 0,
                no_par: '',
                no: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                is_child: item.child.length > 0 ? true : false
              })
              if(item.child.length > 0){
                item.child.map((child, index) => {
                  if(child.child.length > 0){
                    this.list.push(
                      {
                        ...child,
                        num_children: 1,
                        no_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                        no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                        is_child: true
                      }
                    )
                    child.child.map((child2, index2) => {
                      this.is_detail = true
                      this.list.push(
                        {
                          ...child2,
                          num_children: 2,
                          no_par_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                          no_par:index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                          no: index2 + 1,
                          is_child: false
                        }
                      )
                    })
                  } else {
                    this.list.push(
                      {
                        ...child,
                        num_children: 1,
                        no_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                        no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                        is_child: false
                      }
                    )
                  }
                }
                )
                // item.child.map((child, index) => {
                //   this.list.push(
                //     {
                //       ...child,
                //       num_children: 1,
                //       no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : ''
                //     }
                //   )
                // })
                // item.child.map(child => {
                //   if(child.child.length > 0){
                //     child.child.map((child2, index2) => {
                //       this.list.push(
                //         {
                //           ...child2,
                //           num_children: 2,
                //           no: index2 + 1
                //         }
                //       )
                //     })
                //   }
                // })
              }
            })
            this.pagination = res.results.pagination !== undefined ? res.results.pagination : {}
            this.process.load = false
            // this.fetchSummary()
          }
        })
      },

      async save () {
        this.message.error = ''

        this.form.request_file = this.all_document.filter(item => item.type !== 'image')
        this.form.request_image = this.all_document.filter(item => item.type === 'image')

        const isValid = await this.$refs.form.validate(),
              isDocument = this.form.request_file.length > 0 || this.form.request_image.length > 0
        this.message.error = !isValid ? 'Silahkan lengkapi form' : !isDocument ? 'Dokumen Negosiasi harus diisi' :''
        if (isValid && isDocument) {
          this.process.form = true

          // SAVE TO REST API
          await post(`project/negotiation`, {
            data: {
              id: this.form.id,
              negotiation_final_object: {file :{
                "doc": this.form.request_file,
                "image": this.form.request_image
              }}
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetch()

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async statuses () {
        this.message.error = ''
        this.process.status = true

        // SAVE TO REST API
        await post(`project/status`, {
          data: {
            id: this.$route.params.id,
            status: this.selected.status
          }
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.dialog.confirm = false
            this.dialog.fullscreen = false
            this.message.success = res.message
            if (this.selected.status === 'Negosiasi') {
              this.$router.push(`/project/process/negosiasi/${this.form.id}`)
            } else {
              this.$router.push(`/project/process/penawaran/${this.form.id}`)
            }
            this.$emit('reloaddata')

          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper-cco { 
  overflow-y: auto; 
  height: calc(100vh - 250px); 
} 
.wrapper-cco th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-cco-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-cco-col {
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  left: 60px;
}
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>